import { PlanRow, WorkCell } from "./plan-types";

/**
 * Работы со связями, которые правка удаляет целиком (п. 6 ТЗ «Графики»: работа удалена —
 * её связи удаляются с предупреждением). Сервер при сохранении сам перевешивает связи:
 * разделили — исходящие правой части; объединили или перенесли дни на работу того же
 * сотрудника и проекта — туда. Удаляются только связи работы, от которой не осталось
 * ни дня и на чьих днях не встала работа того же проекта, — о них и надо спросить.
 */
export function removedLinkedWorks(baseline: PlanRow[], rows: PlanRow[], linked: Set<string>): string[] {
    if (!linked.size) {
        return [];
    }

    const current = new Set<string>();
    const rowsByEmployer = new Map(rows.map((row) => [row.employerId, row]));

    rows.forEach((row) => eachWork(row, (cell) => cell.assignmentId && current.add(cell.assignmentId)));

    /** Где стояли связанные работы до правки: сотрудник, колонка, проект */
    const places = new Map<string, { employerId: string; column: number; orderId: string }[]>();

    baseline.forEach((row) =>
        eachWork(row, (cell, column) => {
            if (cell.assignmentId && linked.has(cell.assignmentId) && !current.has(cell.assignmentId)) {
                const list = places.get(cell.assignmentId) || [];
                list.push({ employerId: row.employerId, column, orderId: cell.orderId });
                places.set(cell.assignmentId, list);
            }
        })
    );

    const removed: string[] = [];

    places.forEach((list, id) => {
        // на её дне теперь работа того же проекта — «Объединить» или перенос: связи переедут
        const inherited = list.some((place) => {
            const row = rowsByEmployer.get(place.employerId);
            return !!row && worksAt(row, place.column).some((cell) => cell.orderId === place.orderId);
        });

        if (!inherited) {
            removed.push(id);
        }
    });

    return removed;
}

function eachWork(row: PlanRow, visit: (cell: WorkCell, column: number) => void) {
    row.cells.forEach((cell, column) => cell.kind === "work" && visit(cell, column));

    Object.keys(row.overlaps || {}).forEach((key) => (row.overlaps![+key] || []).forEach((cell) => visit(cell, +key)));
}

function worksAt(row: PlanRow, column: number): WorkCell[] {
    const cell = row.cells[column];
    const main = cell && cell.kind === "work" ? [cell] : [];
    return [...main, ...((row.overlaps && row.overlaps[column]) || [])];
}
